export default "__VITE_ASSET__BlJ6C8IV__"